import React from "react";
import PropTypes from "prop-types";
import { LoadingContainer, StyledButton, Mask } from "./style";
import ButtonLoader from "../../Loaders/ButtonLoader";
import RippleButton from "../RippleButton";

const IconButton = (props) => {
    return (
        <RippleButton
            component={StyledButton}
            {...props}
            onClick={
                !props.loading || props.disabled ? props.onClick : () => {}
            }
        >
            {props.loading ? (
                <LoadingContainer>
                    <ButtonLoader />
                </LoadingContainer>
            ) : (
                <Mask
                    icon={props.icon}
                    appearance={props.appearance}
                    iconSize={props.iconSize}
                    {...props.iconProps}
                />
            )}
        </RippleButton>
    );
};

IconButton.defaultProps = {
    iconSize: 16,
    disabled: false,
    iconProps: {},
    appearance: "default",
};

IconButton.propTypes = {
    children: PropTypes.any,
    icon: PropTypes.any,
    size: PropTypes.number,
    loading: PropTypes.bool,
    iconSize: PropTypes.number,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    appearance: PropTypes.string, // default, primary, remove
    rounded: PropTypes.string,
    iconProps: PropTypes.object,
};

export default IconButton;
